export default __webpack_public_path__ + "static/montserrat-v14-latin-300-0c3783781c48cfcea845562c50927569.svg";